module.exports = __webpack_public_path__ + "img/5.550c41d7.png";